/* One Hot Tub — Shopify storefront JS */
(function () {
  "use strict";

  /* ---- mobile nav ---- */
  var burger = document.querySelector("[data-burger]");
  var mnav = document.querySelector(".mobile-nav");
  var overlay = document.querySelector("[data-overlay]");
  function closeAll() {
    document.querySelectorAll(".drawer.open, .mobile-nav.open").forEach(function (e) { e.classList.remove("open"); });
    if (overlay) overlay.classList.remove("open");
    document.body.style.overflow = "";
  }
  function openEl(el) {
    if (!el) return;
    el.classList.add("open");
    if (overlay) overlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  if (burger) burger.addEventListener("click", function () { openEl(mnav); });
  if (overlay) overlay.addEventListener("click", closeAll);
  document.querySelectorAll("[data-close]").forEach(function (b) { b.addEventListener("click", closeAll); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

  /* ---- cart drawer open ---- */
  document.querySelectorAll("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      var drawer = document.querySelector("[data-cart-drawer]");
      if (drawer) { e.preventDefault(); openEl(drawer); }
    });
  });

  /* ---- sticky header shadow ---- */
  var hdr = document.querySelector(".hdr");
  if (hdr) window.addEventListener("scroll", function () {
    hdr.style.boxShadow = window.scrollY > 10 ? "0 6px 24px -16px rgba(31,45,68,.4)" : "0 1px 0 var(--line)";
  }, { passive: true });

  /* ---- PDP gallery thumbs ---- */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main] img");
    g.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        if (main) main.src = t.getAttribute("data-img");
        g.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
      });
    });
  });

  /* ---- qty steppers ---- */
  document.querySelectorAll("[data-qty]").forEach(function (q) {
    var input = q.querySelector("input");
    q.querySelector("[data-qty-down]").addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    q.querySelector("[data-qty-up]").addEventListener("click", function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  /* ---- variant swatches (demo: visual only; Shopify variant JS wires selected_variant) ---- */
  document.querySelectorAll("[data-swatch-group]").forEach(function (grp) {
    grp.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        grp.querySelectorAll("button").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
      });
    });
  });

  /* ---- sticky add-to-cart on scroll past buy box ---- */
  var atc = document.querySelector("[data-sticky-atc]");
  var buybox = document.querySelector("[data-buybox]");
  if (atc && buybox && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { atc.classList.toggle("show", !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(buybox);
  }

  /* ---- scroll reveal ---- */
  var rev = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && rev.length) {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); ro.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: "0px 0px -8% 0px" });
    rev.forEach(function (r) { ro.observe(r); });
  } else rev.forEach(function (r) { r.classList.add("in"); });

  /* ---- AJAX add to cart (Shopify) ---- */
  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      if (!window.fetch) return; // fall back to normal POST
      e.preventDefault();
      var btn = form.querySelector("[type=submit]");
      var label = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.innerHTML = "Adding…"; }
      fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll("[data-cart-count]").forEach(function (c) { c.textContent = cart.item_count; c.style.display = ""; });
          if (btn) { btn.innerHTML = "✓ Added!"; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1400); }
          var drawer = document.querySelector("[data-cart-drawer]");
          if (drawer && drawer.hasAttribute("data-refresh-url")) {
            fetch(drawer.getAttribute("data-refresh-url")).then(function (r) { return r.text(); }).then(function (html) {
              var tmp = document.createElement("div"); tmp.innerHTML = html;
              var fresh = tmp.querySelector("[data-cart-drawer-body]");
              var cur = drawer.querySelector("[data-cart-drawer-body]");
              if (fresh && cur) cur.innerHTML = fresh.innerHTML;
            });
          }
          openEl(drawer);
        })
        .catch(function () { if (btn) { btn.innerHTML = label; btn.disabled = false; } form.submit(); });
    });
  });

  /* ---- newsletter (demo feedback; Shopify customer form posts normally) ---- */
  document.querySelectorAll("[data-nl]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      if (f.hasAttribute("data-demo")) {
        e.preventDefault();
        var msg = f.querySelector("[data-nl-msg]");
        if (msg) msg.textContent = "You're in! Watch your inbox. 🛁";
        f.querySelectorAll("input").forEach(function (i) { if (i.type !== "submit") i.value = ""; });
      }
    });
  });
})();
